import { Injectable } from '@angular/core';

@Injectable()
export class DialogDraftState {
    private readonly sources = new Set<() => boolean>();
    register(source: () => boolean): () => void {
        this.sources.add(source);
        return () => this.sources.delete(source);
    }
    hasUnsavedChanges(): boolean {
        return [...this.sources].some((source) => source());
    }
}
